<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card no-body>
           <orcamento-loading :active="processoCarregamento" :steps="etapasCarregamento" />
            <div v-if="!processoCarregamento">

          <orcamento-cabecalho
            :id="orcamento.id"
            :codigo="orcamento.id"
            :status="orcamentoStatus"
            :razao-social="clientBasicInfo.razao_social"
            :status-cliente="clientBasicInfo.status"
            :data-emissao="orcamento.data_emissao"
            :data-validade="orcamento.data_validade"
            :previsao-fechamento="orcamento.previsao_fechamento"
            :contato="orcamento.contato"
            :cnpj="clientBasicInfo.cnpj"
            :show-duplicar="!disabled"
            :show-imprimir="canPrint && show"
            @voltar="voltarOrcamentos"
            @duplicar="duplicarOrcamento"
            @imprimir="printOrcamento"
          />
          <b-card-body>
            <b-row>
              <b-col>
                <orcamento-itens-tabela
                  :items="orcamentoItens"
                  :filial="getFilial()"
                  :modo-edicao="false"
                  :sort-by.sync="sortBy"
                  :sort-direction.sync="sortDirection"
                  @sort-changed="onSortChanged"
                >
                  <template #alerta="{ item }">
                    <orcamento-item-alerta
                      :key="item.id"
                      v-if="canEdit"
                      :orcamentoId="item.orcamento_id"
                      :orcamentoItemId="item.id"
                      :alertas="montarAlertasItem(item)"
                    ></orcamento-item-alerta>
                  </template>
                </orcamento-itens-tabela>
                <orcamento-avisos></orcamento-avisos>
              </b-col>
            </b-row>
            <forma-pgto
              :key="exibirPagamentoSelecionado"
              :status-orcamento="formaPagamentoEditing"
              :forma-pagamento="this.orcamento.forma_pgto"
              :cond-pagamento="this.orcamento.cond_pgto"
              :obs="this.orcamento.observacao"
              :opcoes-pagamentos-iniciais="opcoesPagamentos"
              :valor-total="valorTotalSum"
            >
            </forma-pgto>
            <b-row class="mt-3 mb-2">
              <b-col md="2">
                <b-button
                  v-if="canEdit && !disabled"
                  v-on:click="confirmarEnvio"
                  :disabled="!podeEnviar"
                  variant="primary"
                  class="orcamento-enviar-button w-100 mb-2"
                >
                  <i class="fa fa-send"></i> Efetivar Pedido
                </b-button>
              </b-col>
              <b-col md="8"></b-col>
              <b-col md="2">
                <b-button
                  v-if="canEdit && !disabled"
                  v-on:click="editOrcamento"
                  class="w-100 mb-2"
                  variant="success"
                >
                  <i class="fa fa-edit"></i> Editar
                </b-button>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col md="12">
                <orcamento-informacao-adicional></orcamento-informacao-adicional>
              </b-col>
            </b-row>
          </b-card-body>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style>
.orcamento-table-card-body {
  overflow: scroll;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0 !important;
}
.orcamento-footer tfoot,
.orcamento-footer tfoot > tr,
.orcamento-footer tfoot > tr > th {
  border: none;
}
.orcamento-footer tfoot > tr > th:nth-child(12),
.orcamento-footer tfoot > tr > th:nth-child(13) {
  border: 1px solid #c8ced3;
}
.orcamento-footer tfoot > tr > th:nth-child(11),
.orcamento-footer tfoot > tr > th:nth-child(12),
.orcamento-footer tfoot > tr > th:nth-child(13) {
  text-align: right;
}
/* .orcamento-table-card-body tbody tr:nth-of-type(odd) .table-success{
  background-color: #cdedd8;
}
.orcamento-table-card-body tbody tr:nth-of-type(even) .table-success{
  background-color: rgba(205, 237, 216, 0.6);
}
.orcamento-table-card-body tbody tr:nth-of-type(odd) .table-info{
  background-color: #d3eef6;
}
.orcamento-table-card-body tbody tr:nth-of-type(even) .table-info{
  background-color: rgba(211, 238, 246, 0.6);
} */
.orcamento-table-card-body tfoot tr th {
  background-color: white;
}
.orcamento-table-card-body tfoot tr:last-child th:hover {
  background-color: white;
}

.btn-flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.div-observacao {
  margin-top: -1%;
  margin-bottom: 1%;
}

.orcamento-enviar-button {
  background-color: #7C3AED !important;
  border-color: #7C3AED !important;
  border-radius: 8px !important;
}

.orcamento-enviar-button:hover:not(:disabled),
.orcamento-enviar-button:focus:not(:disabled) {
  background-color: #5804CA !important;
  border-color: #5804CA !important;
}
</style>

<script>
import Orcamento from "../../../services/orcamento";
import Cliente from "../../../services/cliente";
import OrcamentoAvisos from "./OrcamentoAvisos";
import OrcamentoCabecalho from "./OrcamentoCabecalho";
import OrcamentoItensTabela from "./OrcamentoItensTabela";
import OrcamentoInformacaoAdicional from "./OrcamentoInformacaoAdicional";
import OrcamentoItemAlerta from "./OrcamentoItemAlerta";
import { EventBus } from "../../../helpers/eventBus";
import GrupoPermissao from "../../../services/grupoPermissao";
import FormaPgto from "../FormaPgto";
import Pedido from "../../../services/pedido";
import ValidadorOrcamento from "../../../services/validadores/validadorOrcamento";
import Analytics from "../../../services/analytics";
import OrcamentoLoading from "../../../components/ui/OrcamentoLoading";

export default {
  name: "Orcamento",
  components: {
    OrcamentoAvisos,
    OrcamentoCabecalho,
    OrcamentoItensTabela,
    OrcamentoInformacaoAdicional,
    OrcamentoItemAlerta,
    FormaPgto,
    OrcamentoLoading,
  },
  data: () => ({
    etapasCarregamento: [
      { key: 'orcamento', label: 'Carregando orçamento' },
      { key: 'itens', label: 'Carregando itens do orçamento' },
      { key: 'imposto', label: 'Carregando impostos e margem' },
      { key: 'cliente', label: 'Carregando dados do cliente' },
    ],
    processoCarregamento: false,
    possuiAlteracoesProdutos: false,
    valida: false,
    show: false,
    produtosRetornados: [],
    sortBy: "produto_codigo",
    sortDirection: "asc",
    orcamento: new Object(),
    orcamentoOriginal: new Object(),
    informacoesOrcamento: new Object(),
    orcamentoItens: [],
    currentOrcamentoItem: new Object(),
    orcamento_id: null,
    clientBasicInfo: new Object(),
    filial: "",
    valorMinimoOrcamento: 0,
    efetivandoPedido: false,
    fields: [
      {
        key: "produto_codigo",
        label: "Cód.",
        sortable: true,
        tdClass: "text-right",
        thClass: "text-center",
      },
      { key: "titulo", label: "Descrição", sortable: true },
      {
        key: "quantidade",
        label: "Qtde.",
        sortable: true,
        tdClass: "text-right",
        thClass: "text-center",
      },
      {
        key: "valor_unitario",
        label: "Vl.Unit. S/ ipi",
        sortable: true,
        tdClass: "text-right moeda-real-div ",
        thClass: "text-center ",
      },
      {
        key: "margem_valor",
        label: "Margem Unit.",
        sortable: true,
        tdClass: "text-right moeda-real-div ",
        thClass: "text-center ",
      },
      {
        key: "valor_ipi",
        label: "Valor Ipi Unit.",
        sortable: true,
        tdClass: "text-right moeda-real-div ",
        thClass: "text-center ",
      },
      {
        key: "valor_st",
        label: "Valor St Unit.",
        sortable: true,
        tdClass: "text-right moeda-real-div ",
        thClass: "text-center ",
      },
      {
        key: "valor_bruto_unit",
        label: "Valor Venda Unitário",
        sortable: true,
        tdClass: "text-right moeda-real-div ",
        thClass: "text-center ",
      },
      {
        key: "valor_total",
        label: "Valor Venda Total",
        sortable: true,
        tdClass: "text-right moeda-real-div ",
        thClass: "text-center ",
      },
      {
        key: "valor_comissao",
        label: "Prêmio",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
    ],
    disabled: false,
    alertasCompleta: null,
    opcoesPagamentos: null,
  }),
  computed: {
    canPrint() {
      return this.orcamento.status != "C" && !this.valida;
    },
    podeEnviar() {
      return (
        !this.efetivandoPedido &&
        !this.possuiAlteracoesProdutos &&
        this.orcamentoItens.length == this.produtosRetornados.length &&
        this.valorMinimoOrcamento >= 600
      );
    },
    canEdit() {
      return this.orcamento.status == "D" || this.orcamento.status == "S";
    },
    isEditing() {
      return this.orcamento.status == "D";
    },
    valorTotalSum() {
      return this.orcamentoItens.reduce(function (total, item) {
        return total + item.valor_total * 1;
      }, 0);
    },
    comissaoSum() {
      return this.orcamentoItens.reduce(function (total, item) {
        return total + item.valor_comissao;
      }, 0);
    },
    orcamentoStatus() {
      return this.orcamento.status;
    },
    formaPagamentoEditing() {
      if (this.orcamento.status == "D" || this.orcamento.status == "C") {
        return true;
      }
    },
    exibirPagamentoSelecionado() {
      if (this.orcamento.forma_pgto != "") {
        return this.orcamento.forma_pgto;
      }
    },
  },
  beforeMount() {
    this.validaPermissao();
    this.orcamento_id = this.$route.params.id;
    this.carregarOrcamento(this.orcamento_id);

    EventBus.$on("onBudgetItemHasChanges", (item) => {
      if (this.produtosRetornados.findIndex((idProduto) => idProduto == item.orcamento_item_id) == -1) {
        this.produtosRetornados.push(item.orcamento_item_id);
      }
      if (item.changed) this.possuiAlteracoesProdutos = true;
    });

    ValidadorOrcamento.setarConfiguracao(this.$helper, this.$bvModal);
  },
  methods: {
    validaPermissao() {
      GrupoPermissao.getPermissao("/vendas/orcamentos").then((response) => {
        if (!response.data.data) this.$router.push("/");
        else this.disabled = response.data.data.edita != "1";
      });
    },
    async carregarOrcamento(id) {
      this.processoCarregamento = true;
      const iniciadoEm = Date.now();

      try {
        this.orcamento = new Object();
        const response = await Orcamento.getCompleta(id)
        const data = response.data.data;

        this.orcamentoItens = data.itens || [];
        this.valorMinimoOrcamento = data.valor_unitario_total;
        this.validaTabelaCoorp(this.orcamentoItens);

        const dadosOrcamento = data.orcamento || {};
        this.orcamento = dadosOrcamento;
        this.orcamentoOriginal = Object.assign({}, dadosOrcamento);
        this.$store.commit("orcamento/SALVAR_ORCAMENTO", dadosOrcamento);
        this.$store.commit("orcamento/SALVAR_ORCAMENTO_ORIGINAL", Object.assign({}, dadosOrcamento));
        this.$store.commit(
          "orcamento/ATUALIZAR_VALOR_TOTAL",
          this.orcamentoItens.reduce((total, item) => total + item.valor_total * 1, 0)
        );
        this.informacoesOrcamento = {
          data_validade: dadosOrcamento.data_validade,
          previsao_fechamento: dadosOrcamento.previsao_fechamento,
          contato: dadosOrcamento.contato,
          bo_aceite_informacoes_orcamento: dadosOrcamento.bo_aceite_informacoes_orcamento,
        };
        this.filial = this.orcamento.cd_filial;

        this.clientBasicInfo = data.cliente || new Object();
        if (data.cliente && data.cliente.cnpj) {
          this.$store.state.orcamento.dados.pessoaFisica = data.cliente.cnpj.length === 11;
        }
        this.alertasCompleta = {
          alertasDeMudanca: data.alertasDeMudanca,
          alertasMudancaEstoques: data.alertasMudancaEstoques,
          alertasMudancaPrecoMinimo: data.alertasMudancaPrecoMinimo,
          alertasMultiplos: data.alertasMultiplos,
        };
        this.opcoesPagamentos = data.opcoes_pagamentos != null ? data.opcoes_pagamentos : null;
      } catch (e) {
        this.$helper.showErrorResponse(e);
      }
      finally {
        const decorrido = Date.now() - iniciadoEm;
        const restante = Math.max(0, 5000 - decorrido);
        await new Promise(r => setTimeout(r, restante));
        this.processoCarregamento = false;
      }
    },
    montarAlertasItem(item) {
      if (!this.alertasCompleta) return null;

      const produtoCodigo = item.produto_codigo;
      const produtoKey = String(produtoCodigo);
      const pegarAlertaPorProduto = (mapa) => {
        if (!mapa || typeof mapa !== "object" || Array.isArray(mapa)) return null;
        return mapa[produtoCodigo] || mapa[produtoKey] || null;
      };

      const alertasDeMudanca = this.alertasCompleta.alertasDeMudanca;
      let mudanca = {};
      if (alertasDeMudanca && alertasDeMudanca !== true) {
        const diffs = pegarAlertaPorProduto (alertasDeMudanca);
        if (diffs) {
          mudanca = { [produtoKey]: diffs };
        }
      }

      const estoques = Array.isArray(this.alertasCompleta.alertasMudancaEstoques)
        ? this.alertasCompleta.alertasMudancaEstoques
        : [];
      const estoque = estoques.filter((e) => e.id == item.id);

      let preco_minimo = {};
      const precoMinimoItem = pegarAlertaPorProduto(this.alertasCompleta.alertasMudancaPrecoMinimo);
      if (precoMinimoItem) {
        preco_minimo = { [produtoKey]: precoMinimoItem };
      }

      let multiplos = {};
      const multiplosItem = pegarAlertaPorProduto(this.alertasCompleta.alertasMultiplos);
      if (multiplosItem) {
        multiplos = { [produtoKey]: multiplosItem };
      }

      return { mudanca, estoque, preco_minimo, multiplos };
    },
    async loadOrcamentoItens(orcamento_id) {
      if (orcamento_id == null || orcamento_id == 0) return;
      this.orcamentoItens = [];
      this.produtosRetornados = [];
      this.alertasCompleta = null;

      try {
        const response = await Orcamento.getOrcamentoItens(orcamento_id)
        this.orcamentoItens = response.data.data;
        this.valorMinimoOrcamento = response.data.valor_unitario_total;
        this.validaTabelaCoorp(this.orcamentoItens);
        this.$store.commit(
          "orcamento/ATUALIZAR_VALOR_TOTAL",
          this.orcamentoItens.reduce((total, item) => total + item.valor_total * 1, 0)
        );
        EventBus.$emit("eventoAtualizarPagamento", true);
      } catch (e) {
        if (e.response.status === 404) return;
          this.$helper.showErrorResponse(e);
      }
    },
    validaTabelaCoorp(value) {
      for (let i = 0; i < value.length; i++) {
        if (value[i].vl_liquido_tab_coorp != 0) {
          this.valida = true;
        } else {
          this.show = true;
        }
      }
    },
    async loadClientBasicInfo(cliente_codigo) {
      if (cliente_codigo == null || cliente_codigo == 0) return;
      this.clientBasicInfo = new Object();
      try {
        const response = await Cliente.getBasicInfo(cliente_codigo)
        this.clientBasicInfo = response.data.data;      
        } catch (erro) {
          this.$helper.showErrorResponse(erro);
      }
    },
    onSortChanged() {},
    async confirmarEnvio() {
      if (this.efetivandoPedido) {
        return;
      }

      this.efetivandoPedido = true;

      const envioValido = await ValidadorOrcamento.validarEnvioOrcamento(
        this.clientBasicInfo.status,
        this.orcamento,
        this.orcamentoItens,
        this.informacoesOrcamento,
        this.orcamentoOriginal
      );

      if (!envioValido) {
        this.efetivandoPedido = false;
        return;
      }

      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que deseja enviar Orçamento Nº. " +
            this.orcamento.id +
            ", depois de enviado não será mais possível alterá-lo?",
          {
            title: "Atenção",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "Sim",
            cancelTitle: "Não",
            cancelVariant: "danger",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirmado) => {
          if (confirmado) {
            this.enviarOrcamento();
          } else {
            this.efetivandoPedido = false;
          }
        })
        .catch((erro) => {
          this.efetivandoPedido = false;
          this.$helper.showErrorResponse(erro);
        })
    },
    getFilial() {
      return this.filial == 1 ? "Maringá - PR" : "Navegantes - SC";
    },
    enviarOrcamento() {
      if (this.$store.state.ui.salvandoPedido) {
        return;
      }

      this.efetivandoPedido = true;
      this.$store.commit('ui/SALVANDO_PEDIDO', true);

      const dadosOrcamento = {
        orcamento: this.orcamento,
        itens: this.orcamentoItens,
        cd_filial: this.orcamento.cd_filial,
        valor_total: this.valorTotalSum,
      };
      const dadosPedido = Pedido.criarPedidoData(dadosOrcamento);

      this.$store.commit('ui/LOADING_MSG', "Enviando Pedido de Venda…");

      Orcamento.sendOrcamento(this.orcamento.id, dadosPedido)
        .then(() => {
          this.$helper.showMsg('Pedido enviado com sucesso!', 'success');
          Analytics.trackPurchase({
            idPedido: dadosPedido.codigo || this.orcamento.id,
            valorTotal: this.valorTotalSum,
            itens: this.orcamentoItens,
            cd_filial: this.orcamento.cd_filial
          }, this.$store);
          this.$router.push("/vendas/orcamentos");
        })
        .catch((erro) => {
          this.$helper.showErrorResponse(erro);
        })
        .finally(() => {
          this.efetivandoPedido = false;
          this.$store.commit('ui/LOADING_MSG', "");
          this.$store.commit('ui/SALVANDO_PEDIDO', false);
        });
    },
    printOrcamento() {
      this.$store.commit('ui/LOADING_MSG', "Gerando proposta do orçamento...");
      Orcamento.printOrcamento(this.orcamento.id)
        .then((response) => {
          let fileURL = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "application/pdf",
            })
          );
          let windowPrint = window.open(fileURL, "about:blank");
          windowPrint.print();
        })
        .catch((e) => {
          debugger;
          this.$helper.showErrorResponse(e);
        })
        .finally(() => {
          this.$store.commit('ui/LOADING_MSG', "");
        })
    },
    voltarOrcamentos() {
      this.$router.push("/vendas/orcamentos");
    },
    duplicarOrcamento() {
      Orcamento.duplicarOrcamento(this.orcamento)
        .then((response) => {
          this.$helper.showMsg(response.data.msg, response.data.type);
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        });
    },
    editOrcamento() {
      this.$router.push(
        "/vendas/orcamentos/orcamento/" + this.orcamento.id + "/editar"
      );
    },
  },
};
</script>
